<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import Button from 'primevue/button';
import Card from 'primevue/card';

import { useSegmentSelection } from '../composables/useSegmentSelection';

const { selectedSegmentId, unrequiredSegments, handleNextView } = useSegmentSelection();

const route = useRoute();
watch(
  () => route.path,
  () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <Card class="h-max flex-1 basis-[354px] border border-gray-200 !shadow-none">
    <template #content>
      <section v-auto-animate class="">
        <div class="space-y-9">
          <div class="grid grid-cols-4 gap-6">
            <button
              :key="segment.id"
              v-for="segment in unrequiredSegments"
              class="flex flex-col items-center gap-4 rounded-[10px] border p-6 transition-colors"
              :class="{
                'border-brand-300 bg-brand-50 text-brand-500': selectedSegmentId === segment.id,
                'border-gray-200 bg-white text-gray-800 hover:border-brand-300 hover:bg-brand-50 hover:text-brand-500':
                  selectedSegmentId !== segment.id,
              }"
              @click="selectedSegmentId = segment.id"
            >
              <span class="font-semibold">{{ segment.name }}</span>
            </button>
          </div>

          <div class="flex justify-center gap-6">
            <RouterLink
              :to="{
                name: 'CalculationSummaryView',
                params: {
                  ...$route.params,
                },
              }"
            >
              <Button class="font-semibold" severity="secondary" outlined size="small">
                Wstecz
              </Button>
            </RouterLink>

            <Button
              class="font-semibold"
              size="small"
              :disabled="!selectedSegmentId"
              @click="handleNextView"
            >
              Dodaj technologię
              <i class="pi pi-arrow-right"></i>
            </Button>
          </div>
        </div>
      </section>
    </template>
  </Card>
</template>
